import { Organization } from '../global';

export const AGENCY_ORGANIZATION_SEARCH = 'AGENCY_ORGANIZATION_SEARCH';
export const AGENCY_ORGANIZATION_SEARCH_RESULT = 'AGENCY_ORGANIZATION_SEARCH_RESULT';
export const AGENCY_ORGANIZATION_TYPE = 'AGENCY_ORGANIZATION_TYPE';
export const SUBMIT_AGENCY_FORM = 'SUBMIT_AGENCY_FORM';
export const SUBMIT_AGENCY_FAILED = 'SUBMIT_AGENCY_FAILED';
export const RESET_AGENCY_FORM = 'RESET_AGENCY_FORM';
export const EDIT_AGENCY_FORM = 'EDIT_AGENCY_FORM';
export const CANCEL_EDIT_AGENCY_FORM = 'CANCEL_EDIT_AGENCY_FORM';

export interface AgencyOrganizationData {
  agencyOrganizations?: Organization[];
  formValues?: { [key: string]: [value: string] };
  isFormSubmitted?: Boolean;
  agencyDetails?: AgencyDetails;
  isFormEditable?: Boolean;
}

export interface AgencyDetails {
  code?: string;
  status?: string;
  businessType?: string;
  category?: string;
  organizationName?: string;
  organizationNameInFrench?: string;
  logoFile?: string;
  paymentGateway?: Array<string>;
  branchCode?: string;
  rootOrganizationCode?: string;
  parentOrganizationCode?: string;
  affiliationCode?: string;
  companyWebsite?: string;
  policyPrefix?: string;
  premiumMethod?: string;
  defaultServiceAccount?: string;
  whiteLabelAccount?: string;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: Date;
  updatedAt?: Date;
  contract?: Contract[];
  contacts?: Contacts[];
  distributionLicenses?: DistributionLicense[];
  programCode?: string;
  BDM?: string;
  changeHistory?: ChangeHistory[];
}
export interface Override {
  organization?: string;
  effectiveDate?: Date;
  amount?: number;
}
export class ChangeHistoryDetail {
  fieldChanged?: string;
  from?: unknown;
  to?: unknown;
}
export class ChangeHistory {
  createdBy?: string;
  createdAt?: Date;
  changeDetails?: ChangeHistoryDetail[];
}
export interface Contract {
  sponsorCode?: string;
  override?: Override[];
  banking?: Banking;
  effectiveDate?: Date;
  expiryDate?: Date;
  exclusiveContract?: boolean;
  saleOfChannels?: Array<string>;
  legalEntity?: LegalEntity;
  compensationCode?: string;
  payFrequency?: string;
  commissionRecipient?: boolean;
}
export interface Banking {
  bankName?: string;
  bankTransit?: string;
  bankNumber?: string;
  accountNumber?: string;
  bankProvince?: string;
}
export interface LegalEntity {
  legalName: string;
  tradeName: string;
  HSTNumber: string;
  hasHST: boolean;
  CRANumber: string;
  BusinessNumber: string;
  QSTNumber: string;
  QuebecNumber: string;
  email: string;
  addressLine1: string;
  addressLine2: string;
  postalCode: string;
  city: string;
  province: string;
  country: string;
}

export interface Contacts {
  isMain: boolean;
  contactName: string;
  contactType: string;
  effectiveDate: Date;
  expiryDate: Date;
  email: string;
  phone: string;
  hoursOfOperations: string;
  hoursOfOperationsFr: string;
}

export interface DistributionLicense {
  id?: number;
  licensedProvince: string;
  licenseNumber?: string;
  status?: string;
  effectiveDate?: Date;
  expiredDate?: Date;
  screeningStatus?: string;
  legalName?: string;
  screeningEffectiveDate?: Date;
}
export interface Error {
  statusCode: number;
  message: string;
}